import { UserFavorite } from "src/models";
import { ModalsType } from "../types";
import { createAction } from "./create.action";

export namespace ModalsAction {

    export const showLogin = () => createAction(ModalsType.SHOW_LOGIN_MODAL);
    export const hideLogin = () => createAction(ModalsType.HIDE_LOGIN_MODAL);

    export const showLogout = () => createAction(ModalsType.SHOW_LOGOUT_MODAL);
    export const hideLogout = () => createAction(ModalsType.HIDE_LOGOUT_MODAL);

    export const showProfile = () => createAction(ModalsType.SHOW_PROFILE_MODAL);
    export const hideProfile = () => createAction(ModalsType.HIDE_PROFILE_MODAL);

    export const showPackages = () => createAction(ModalsType.SHOW_PACKAGES_MODAL);
    export const hidePackages = () => createAction(ModalsType.HIDE_PACKAGES_MODAL);

    export const showReport = () => createAction(ModalsType.SHOW_REPORT_MODAL);
    export const hideReport = () => createAction(ModalsType.HIDE_REPORT_MODAL);

    export const showShare = () => createAction(ModalsType.SHOW_SHARE_MODAL);
    export const hideShare = () => createAction(ModalsType.HIDE_SHARE_MODAL);

    export const showGift = () => createAction(ModalsType.SHOW_GIFT_MODAL);
    export const hideGift = () => createAction(ModalsType.HIDE_GIFT_MODAL);

    export const showDeviceAccess = () => createAction(ModalsType.SHOW_DEVICE_ACCESS_MODAL);
    export const hideDeviceAccess = () => createAction(ModalsType.HIDE_DEVICE_ACCESS_MODAL);

    export const showMessageModal = () => createAction(ModalsType.SHOW_MESSAGE_MODAL);
    export const hideMessageModal = () => createAction(ModalsType.HIDE_MESSAGE_MODAL);

    export const showFavorites = (fav: UserFavorite) => createAction(ModalsType.SHOW_FAVORITE_MODAL, fav);
    export const hideFavorites = () => createAction(ModalsType.HIDE_FAVORITE_MODAL);

    export const showFavoritesNoSport = () => createAction(ModalsType.SHOW_FAVORITE_NO_SPORT_MODAL);
    export const hideFavoritesNoSport = () => createAction(ModalsType.HIDE_FAVORITE_NO_SPORT_MODAL);

    export const showLoginPermission = (from: string) => createAction(ModalsType.SHOW_LOGIN_PERMISSION_MODAL, from);
    export const hideLoginPermission = () => createAction(ModalsType.HIDE_LOGIN_PERMISSION_MODAL);

    export const showCompleteProfile = () => createAction(ModalsType.SHOW_COMPLETE_PROFILE_MODAL);
    export const hideCompleteProfile = () => createAction(ModalsType.HIDE_COMPLETE_PROFILE_MODAL);

    export const showProfileCompletedMessage = () => createAction(ModalsType.SHOW_PROFILE_COMPLETED_MESSAGE_MODAL);
    export const hideProfileCompletedMessage = () => createAction(ModalsType.HIDE_PROFILE_COMPLETED_MESSAGE_MODAL);
}